import React from 'react';

export default function AgentPopoutIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="0.75" width="12.5" height="12.5" rx="1.25" stroke="#636363" strokeWidth="1.5" />
      <path d="M5 3H11V9L8 6L5 3Z" fill="#636363" />
      <rect x="5.18408" y="7.89478" width="5.0025" height="1.5" transform="rotate(-45 5.18408 7.89478)" fill="#636363" />
    </svg>
  );
}
